import { SyntheticEvent, useState } from 'react';

import { ApplicationInfoTab } from './ApplicationInfoTab';
import { ATSPrincipalAppCandidateModalTabsTestIds } from 'data-testids/ATS';
import { AttachmentsInfoTab } from './AttachmentInfoTab';
import { BasicInfoTab } from './BasicInfo/BasicInfoTab';
import { Box, Tab, Tabs } from '@mui/material';
import { CandidateModalTabsProps, TabPanelProps } from 'features/Principal/types/modalTypes';
import { candidateTabs } from '../data';
import { QualificationsTab } from './QualificationsTab/QualificationsTab';
import { ExperienceTab } from './ExperienceTab';

export const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      data-testid={ATSPrincipalAppCandidateModalTabsTestIds.TAB_PANEL}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

export const CandidateModalTabs: React.FC<CandidateModalTabsProps> = ({ row, onEmailClick }) => {
  const [value, setValue] = useState(0);

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    const tab = candidateTabs.find((t) => t.value === newValue);
    if (tab?.isResume) return;
    setValue(newValue);
  };

  return (
    <Box
      sx={{ width: '100%' }}
      data-testid={ATSPrincipalAppCandidateModalTabsTestIds.TABS_CONTAINER}
    >
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange}>
          {candidateTabs.map((tab) =>
            tab.isResume ? (
              <Tab
                key={tab.value}
                label={tab.label}
                onClick={() => window.open(row.candidate.profile.resume, '_blank')}
                data-testid={ATSPrincipalAppCandidateModalTabsTestIds.TAB_BUTTON}
                value={tab.value}
              />
            ) : (
              <Tab
                key={tab.value}
                value={tab.value}
                label={tab.label}
                data-testid={ATSPrincipalAppCandidateModalTabsTestIds.TAB_BUTTON}
              />
            )
          )}
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <BasicInfoTab row={row} onEmailClick={onEmailClick} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <QualificationsTab row={row} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <ExperienceTab previousPositions={row.candidate.previous_positions} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={4}>
        <ApplicationInfoTab
          nimbleAnswers={row.candidate.nimble_answers}
          customAnswers={row.application.questions.custom_answers}
          videoUrls={row.application.questions.applicationattachmentvideourl_set}
        />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={5}>
        <AttachmentsInfoTab attachments={row.application.questions?.applicationattachment_set} />
      </CustomTabPanel>
    </Box>
  );
};
